import { SelfServiceUserAccount } from '@ekt-group/general-purpose-api-interfaces';

import { createCommonStore } from '.';

interface UserInfoStore {
  selectedAccount?: SelfServiceUserAccount;
  setSelectedAccount: (account: SelfServiceUserAccount) => void;

  hasSelectedAccountFirstTime?: boolean;
  setHasSelectedAccountFirstTime: (value: boolean) => void;

  locale: string;
  setLocale: (locale: string) => void;
}

export const useUserInfoStore = createCommonStore<UserInfoStore>(
  (set) => ({
    selectedAccount: {
      code: '',
      name: '',
      permissions: [],
      role: null,
    },
    setSelectedAccount: (account) => set({ selectedAccount: account }),
    hasSelectedAccountFirstTime: false,
    setHasSelectedAccountFirstTime: (value) => set({ hasSelectedAccountFirstTime: value }),
    locale: 'et',
    setLocale: (locale) => set({ locale }),
  }),
  {
    name: 'user-info-store',
    storage: 'session',
    partialize: (state) => ({
      hasSelectedAccountFirstTime: state.hasSelectedAccountFirstTime,
      locale: state.locale,
      selectedAccount: state.selectedAccount,
    }),
  },
);
